import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed z-[999] top-0 w-full left-0" }
const _hoisted_2 = { class: "flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-gray-300 opacity-50" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline-block sm:align-middle sm:h-screen" }, "​", -1)
const _hoisted_5 = { class: "bg-white text-primary p-4 flex items-start relative" }
const _hoisted_6 = { class: "text-primary font-bold uppercase text-xl" }
const _hoisted_7 = { class: "bg-white text-primary p-4" }
const _hoisted_8 = { class: "bg-white p-4 text-right" }

import IconCross from '@/components/Icons/IconCross.vue'
import { onClickOutside } from '@vueuse/core'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GenericModal',
  props: {
    title: {},
    defaultMaxWidth: { type: Boolean, default: true },
    canClose: { type: Boolean, default: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const modal = ref(null)



const emit = __emit

onClickOutside(modal, () => {
  emit('close', true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass(["inline-block align-center bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full", { 'sm:max-w-lg': _ctx.defaultMaxWidth, 'sm:max-w-4xl': !_ctx.defaultMaxWidth }]),
        role: "dialog",
        ref_key: "modal",
        ref: modal,
        "aria-modal": "true",
        "aria-labelledby": "modal-headline"
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.title), 1),
          (_ctx.canClose)
            ? (_openBlock(), _createBlock(IconCross, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close', true))),
                class: "absolute right-4 top-5 size-3 cursor-pointer"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "body")
        ]),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ], 2)
    ])
  ]))
}
}

})